import { useState, useEffect, useMemo } from "react";
import { UserApi } from "../api/user.api";

export const useAuth = () => {

  const [user, setUser] = useState(null); 
  const [loading, setLoading] = useState(true);

  const users = useMemo(() => UserApi(), []);

  useEffect(() => {

    const checkAuth = async () => {
      try {
        const { data } = await users.findCurUser();

        if (data.success) { 
          setUser(data);
        } else {
          setUser(null);
        }

      } catch (err) {
        setUser(null);
      } finally {
        setLoading(false);
      }
    };

    checkAuth();

  }, [users]);

  return { user, loading };
};
